import { Injectable } from '@angular/core';
import { UserMenuService } from './base-user-menu.service';

@Injectable({
  providedIn: 'root',
})
export class UserMenuRegistry {
  private activeService: UserMenuService | null = null;

  registerService(service: UserMenuService): void {
    this.activeService = service;
  }

  unregisterService(): void {
    this.activeService = null;
  }

  getActiveService(): UserMenuService | null {
    return this.activeService;
  }
}
